import { render, staticRenderFns } from "./Paginated.vue?vue&type=template&id=4f041bb2"
import script from "./Paginated.vue?vue&type=script&lang=js"
export * from "./Paginated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports